import { normalizeVistasIdsFromExtras } from "../config/auxCamposPipeline";

function auxNombre(auxiliares, tabla, id) {
  if (id == null || id === "") return null;
  const row = (auxiliares[tabla] || []).find((x) => String(x.id) === String(id));
  return row?.nombre || null;
}

function pushLine(lines, label, value) {
  if (value == null || value === "" || value === false) return;
  if (value === true) {
    lines.push(`${label}: Sí`);
    return;
  }
  lines.push(`${label}: ${value}`);
}

function pushBool(lines, form, key, label) {
  // Solo atributos positivos: «Ascensor: No» hacía que la IA escribiera «sin ascensor».
  if (form[key] === true) lines.push(`${label}: Sí`);
}

/** Suaviza etiquetas tipo «Amueblado completo» para no empujar adverbios al anuncio. */
function etiquetaEstadoParaIA(nombre) {
  const n = String(nombre || "").trim();
  if (!n) return null;
  if (/complet|totalmente|total\b/i.test(n) && /amueblad/i.test(n)) return "Amueblado";
  if (/complet|totalmente|total\b/i.test(n) && /reformad|renovad|restaurad/i.test(n)) {
    return n.replace(/\b(completamente|totalmente|completo|total)\b/gi, "").replace(/\s{2,}/g, " ").trim() || "Reformado";
  }
  return n;
}

/** Opción de ficha «Parcial» → anuncio «semiamueblada», no «muebles de tipo parcial». */
function etiquetaMueblesParaIA(nombre) {
  const n = String(nombre || "").trim();
  if (!n) return null;
  if (/^parcial$/i.test(n) || /parcialmente\s+amueblad/i.test(n) || /^semi-?amueblad/i.test(n)) {
    return "Semiamueblada";
  }
  return etiquetaEstadoParaIA(n);
}

const EQUIP_BOOL = [
  ["eq_calefaccion", "Calefacción"],
  ["eq_aire", "Aire acondicionado"],
  ["eq_ascensor", "Ascensor"],
  ["eq_chimenea", "Chimenea"],
  ["eq_gas", "Gas"],
  ["eq_agua", "Agua"],
  ["eq_agua_riego", "Agua de riego"],
  ["eq_pozo_agua", "Pozo de agua"],
  ["eq_luz", "Luz"],
  ["eq_luz_solar", "Luz solar"],
  ["eq_luz_solar_preinst", "Preinst. luz solar"],
  ["eq_lavadero", "Lavadero"],
  ["eq_ducha_exterior", "Ducha exterior"],
  ["eq_doble_cristal", "Doble cristal"],
  ["eq_parcela_vallada", "Parcela vallada"],
  ["eq_cocina_verano", "Cocina de verano"],
  ["eq_trastero", "Trastero"],
  ["eq_piscina_priv", "Piscina privada"],
  ["eq_piscina_comun", "Piscina comunitaria"],
  ["eq_zonas_comunes", "Zonas comunes"],
  ["eq_zona_infantil", "Zona infantil"],
  ["eq_zonas_verdes", "Zonas verdes / jardín comunitario"],
  ["eq_gimnasio", "Gimnasio"],
  ["eq_barbacoa", "Barbacoa"],
  ["eq_padel", "Pista de pádel"],
  ["eq_tenis", "Pista de tenis"],
  ["eq_conserje", "Conserje"],
  ["eq_casita_aperos", "Casita aperos"],
  ["eq_alarma", "Alarma"],
  ["eq_puerta_blindada", "Puerta blindada"],
  ["eq_puerta_antiokupa", "Puerta antiokupa"],
  ["eq_caja_fuerte", "Caja fuerte"],
  ["eq_vigilancia", "Vigilancia"],
  ["eq_domotica", "Domótica"],
  ["eq_punto_recarga", "Punto recarga vehículo eléctrico"],
  ["eq_acceso_discap", "Acceso discapacitados"],
  ["eq_adaptado", "Adaptado discapacidad"],
  ["eq_salida_humos", "Salida de humos"],
  ["eq_edif_uso_viviendas", "Edificio uso viviendas"],
  ["eq_tv_sat", "TV satélite"],
];

const OBS_LABELS = {
  m2_construidos_obs: "Obs. m² construidos",
  m2_utiles_obs: "Obs. m² útiles",
  m2_terrazas_obs: "Obs. m² terrazas",
  m2_jardin_obs: "Obs. m² jardín",
  m2_parcela_obs: "Obs. m² parcela",
  num_terrazas_obs: "Obs. terrazas",
  num_terrazas_balcones_obs: "Obs. terrazas/balcones",
  num_balcones_obs: "Obs. balcones",
  num_patio_obs: "Obs. patio",
  num_dormitorios_obs: "Obs. dormitorios",
  num_banos_obs: "Obs. baños",
  num_aseos_obs: "Obs. aseos",
  plantas_inmueble_obs: "Obs. plantas inmueble",
  plantas_edificio_obs: "Obs. plantas edificio",
  altura_planta_obs: "Obs. altura planta",
  cocina_amueblada_obs: "Obs. cocina",
  armarios_obs: "Obs. armarios",
  eq_garaje_obs: "Obs. garaje",
  eq_trastero_obs: "Obs. trastero",
  eq_calefaccion_obs: "Obs. calefacción",
  eq_aire_obs: "Obs. aire acondicionado",
  eq_piscina_priv_obs: "Obs. piscina privada",
  eq_piscina_comun_obs: "Obs. piscina comunitaria",
  ub_primera_linea_obs: "Obs. 1ª línea playa",
  ub_segunda_linea_obs: "Obs. 2ª línea playa",
  ub_distancia_mar_obs: "Distancia al mar (m)",
  ub_afectacion_costas_obs: "Obs. no afectado (costas)",
  ub_dpmt_obs: "Obs. DPMT",
  ub_serv_transito_obs: "Obs. serv. tránsito",
  ub_serv_proteccion_obs: "Obs. serv. protección",
  gastos_comunidad_obs: "Obs. gastos comunidad",
  basuras_obs: "Obs. basuras",
  ibi_obs: "Obs. IBI",
  valoracion_obs: "Obs. valoración",
  hipoteca_obs: "Obs. hipoteca",
};

/**
 * Etiqueta de garaje para la IA: en el CRM «garaje» abarca tanto una plaza cerrada
 * como un parking abierto (atributos abierto/cerrado/cubierto/interior/exterior en garaje_tipos).
 * Si es abierto (y no consta cerrado) se llama «Parking» sin decir «abierto»; si es
 * cerrado se llama «Garaje». Cubierto/interior/exterior se añaden como matiz cuando constan.
 */
function garajeEtiquetaIA(form) {
  const raw = form.garaje_tipos;
  const keys = Array.isArray(raw)
    ? raw.map((x) => String(x).toLowerCase())
    : String(raw || "").split(",").map((s) => s.trim().toLowerCase()).filter(Boolean);
  const hasAbierto = keys.includes("abierto");
  const hasCerrado = keys.includes("cerrado");
  const hasCubierto = keys.includes("cubierto");
  const hasInterior = keys.includes("interior");
  const hasExterior = keys.includes("exterior");
  const base = hasAbierto && !hasCerrado ? "Parking" : "Garaje";
  const mods = [];
  if (hasCubierto) mods.push("cubierto");
  if (hasInterior) mods.push("interior");
  if (hasExterior) mods.push("exterior");
  if (mods.length) return `${base} ${mods.join(" y ")}`;
  if (hasCerrado) return `${base} cerrado`;
  return base;
}

/**
 * Contexto estructurado para IA: solo datos reales de la ficha (sin inventar).
 */
export function buildContextoPropiedadIA(form, auxiliares = {}, superficies = []) {
  const generales = [];
  const distribucion = [];
  const acabados = [];
  const equipamiento = [];
  const ubicacion = [];
  const observaciones = [];

  // Referencia y calificación energética no se pasan a la IA (no deben salir en el anuncio).
  pushLine(generales, "Título interno", form.titulo);
  pushLine(generales, "Tipo", auxNombre(auxiliares, "tipo-inmueble", form.tipo_inmueble_id));
  pushLine(generales, "Operación", form.operacion);
  pushLine(generales, "Etiqueta", auxNombre(auxiliares, "etiqueta", form.etiqueta_id));
  pushLine(generales, "Estado del inmueble", etiquetaEstadoParaIA(auxNombre(auxiliares, "estado-inmueble", form.estado_inmueble_id)));
  pushLine(generales, "Orientación", auxNombre(auxiliares, "orientacion", form.orientacion_id));
  pushLine(generales, "Año reforma", form.ano_reforma);
  // Campo toggle «Exterior» de ficha: no pasarlo a la IA (no debe salir en el anuncio).
  pushBool(generales, form, "planos", "Planos disponibles");
  pushBool(generales, form, "inspeccion_ite", "Inspección ITE");
  // Cédula de habitabilidad no se pasa a la IA (nunca debe salir en el anuncio).
  // VPO no se pasa a la IA (nunca debe salir en el anuncio).

  pushLine(distribucion, "Nº terrazas", form.num_terrazas ?? form.num_terrazas_balcones);
  pushLine(distribucion, "Nº balcones", form.num_balcones);
  pushLine(distribucion, "Nº patios", form.num_patio);
  pushLine(distribucion, "Dormitorios", form.num_dormitorios);
  pushLine(distribucion, "Baños", form.num_banos);
  pushLine(distribucion, "Aseos", form.num_aseos);
  pushLine(distribucion, "Plantas del inmueble", form.plantas_inmueble);
  pushLine(distribucion, "Plantas del edificio", form.plantas_edificio);
  pushLine(distribucion, "Altura planta", form.altura_planta);

  pushLine(acabados, "Carpintería interior", auxNombre(auxiliares, "carpinteria-interior", form.carpinteria_int_id));
  pushLine(acabados, "Carpintería exterior", auxNombre(auxiliares, "carpinteria-exterior", form.carpinteria_ext_id));
  pushLine(acabados, "Suelos", auxNombre(auxiliares, "suelos", form.suelos_id));
  pushBool(acabados, form, "amueblado", "Amueblado");
  if (form.amueblado) {
    pushLine(acabados, "Tipo muebles", etiquetaMueblesParaIA(auxNombre(auxiliares, "muebles", form.muebles_id)));
  }
  pushBool(acabados, form, "cocina_amueblada", "Cocina amueblada");
  pushBool(acabados, form, "armarios", "Armarios");
  pushBool(acabados, form, "cocina_abierta", "Cocina abierta / americana");

  for (const [key, label] of EQUIP_BOOL) pushBool(equipamiento, form, key, label);
  if (form.eq_garaje) {
    pushLine(equipamiento, "Garaje/parking", garajeEtiquetaIA(form));
  }
  if (form.eq_calefaccion) {
    pushLine(equipamiento, "Tipo calefacción", auxNombre(auxiliares, "calefaccion", form.eq_calefaccion_id));
  }
  if (form.eq_aire) {
    pushLine(equipamiento, "Tipo aire acondicionado", auxNombre(auxiliares, "aire-acondicionado", form.eq_aire_id));
  }
  if (form.eq_piscina_priv) {
    pushLine(equipamiento, "Tipo piscina privada", auxNombre(auxiliares, "piscina", form.eq_piscina_priv_id));
  }
  if (form.eq_piscina_comun) {
    pushLine(equipamiento, "Tipo piscina comunitaria", auxNombre(auxiliares, "piscina", form.eq_piscina_comun_id));
  }

  const pob = form.poblacion_nombre
    || auxNombre(auxiliares, "poblacion", form.poblacion_id)
    || form.poblacion;
  // Solo población: no pasar urbanización/zona (localizan la vivienda en el anuncio).
  pushLine(ubicacion, "Población", pob);

  const vistaIds = normalizeVistasIdsFromExtras(form);
  const vistasNombres = vistaIds
    .map((vid) => auxNombre(auxiliares, "vistas", vid))
    .filter(Boolean);
  if (vistasNombres.length) pushLine(ubicacion, "Vistas", vistasNombres.join(", "));

  pushBool(ubicacion, form, "ub_primera_linea", "Primera línea de playa");
  pushBool(ubicacion, form, "ub_segunda_linea", "Segunda línea de playa");
  if (form.ub_distancia_mar) {
    pushLine(ubicacion, "Distancia al mar", form.ub_distancia_mar_obs ? `${form.ub_distancia_mar_obs} m` : "Indicada en ficha");
  }
  pushBool(ubicacion, form, "ub_dpmt", "DPMT");
  pushBool(ubicacion, form, "ub_serv_transito", "Servidumbre tránsito");
  pushBool(ubicacion, form, "ub_serv_proteccion", "Servidumbre protección");

  for (const [key, label] of Object.entries(OBS_LABELS)) {
    const v = form[key];
    if (v != null && String(v).trim()) observaciones.push(`${label}: ${String(v).trim()}`);
  }
  if (form.eq_observaciones?.trim()) {
    observaciones.push(`Observaciones equipamiento: ${form.eq_observaciones.trim()}`);
  }

  const supLines = (superficies || [])
    .filter((s) => s && (s.nombre || s.observaciones))
    .map((s) => {
      let t = s.nombre || "Planta";
      if (s.observaciones?.trim()) t += `: ${s.observaciones.trim()}`;
      return t;
    });

  const section = (title, lines) => (lines.length ? `### ${title}\n${lines.join("\n")}` : "");

  const bloques = [
    "DATOS VERIFICADOS DE LA PROPIEDAD (usa SOLO esta información; no añadas nada que no figure aquí):",
    section("Generales", generales),
    section("Distribución por plantas", [...distribucion, ...supLines]),
    section("Acabados e interiores", acabados),
    section("Equipamiento", equipamiento),
    section("Ubicación y entorno", ubicacion),
    section("Observaciones de la ficha", observaciones),
  ].filter(Boolean);

  return bloques.join("\n\n");
}
